<template>
  <div>
    <el-table
      v-bind:data="displayLifestyle"
      :show-header="false"
      row-key="id"
      @row-click="selectRow"
      :expand-row-keys="expand"
      empty-text="No food, water, or bowel movements recorded"
      style="width: 100%"
    >
      <!-- Expandable message history list -->
      <el-table-column type="expand">
        <template slot-scope="scope">
          <FoodAnalysis
            v-if="scope.row.id == 'food'"
            :food="food"
          ></FoodAnalysis>
          <WaterAnalysis
            v-if="scope.row.id == 'water'"
            :water="water"
          ></WaterAnalysis>
          <ExcretionAnalysis
            v-if="scope.row.id == 'excretion'"
            :excretion="excretion"
          ></ExcretionAnalysis>
        </template>
      </el-table-column>

      <el-table-column width="50">
        <template slot-scope="scope">
          <img class="lifestyle-icon" :src="getImage(scope.row.id)" />
        </template>
      </el-table-column>

      <el-table-column prop="title" width="250">
        <template slot-scope="scope">
          <div style="line-height:16px">
            <strong>{{ getTitle(scope.row.id) }}</strong>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="110">
        <template slot-scope="scope">
          <span class="times-count">{{
            formatCount(scope.row.event.length, "time")
          }}</span>
        </template>
      </el-table-column>

      <el-table-column width="300">
        <template slot-scope="scope">
          <CalorieColumn v-if="scope.row.id === 'food'" :food="food">
          </CalorieColumn>
          <DateRange 
            :row="scope.row" 
            :patient="patient"
            v-if="scope.row.id === 'excretion'">
          </DateRange>
          <!-- <DateRange :row="scope.row"></DateRange> -->
        </template>
      </el-table-column>

      <el-table-column width="300">
        <template slot-scope="scope">
          <PortionColumn v-if="scope.row.id === 'food'" :food="food">
          </PortionColumn>

          <!-- <DateRange :row="scope.row"></DateRange> -->
        </template>
      </el-table-column>

      <el-table-column>
        <template slot-scope="scope">
          <div>
            <!-- graph -->
          </div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" width="50">
        <template slot-scope="scope">
          <div style="margin-top: 10px;">
            <img
              v-if="expand.length && expand[0] === scope.row.id"
              src="../../images/up-arrow.png"
              width="21px"
              height="21px"
            />
            <img
              v-else
              src="../../images/down-arrow.png"
              width="21px"
              height="21px"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="show-more" v-if="showRows < lifestyle.length">
      <el-button type="text" @click="showMore">
        {{ showMoreText }}&nbsp;<i class="el-icon-arrow-down"></i>
      </el-button>
    </div>
    <div class="show-more" v-if="showRows >= lifestyle.length && this.showLess">
      <el-button type="text" @click="showLessHandler">
        {{ showLessText }}&nbsp;<i class="el-icon-arrow-up"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import CardTable from "../component/table";
import { mapState, mapGetters, mapActions } from "vuex";

import FoodComponents from "./food/components";
import WaterComponents from "./water/components";
import ExcretionComponents from "./excretion/components";

// import LifestyleAnalysis from './Analysis'

export default {
  name: "patient-lifestyle-card-table",
  extends: CardTable,

  props: {
    patient: {
      type: Object,
      required: true,
    },
    food: {
      type: Array,
    },
    water: {
      type: Array,
    },
    excretion: {
      type: Array,
    },
  },

  data() {
    return {
      showRows: 3,
      showLess: false,
    };
  },

  methods: {
    getTitle(type) {
      if (type == "food") return "Food";
      if (type == "water") return "Water";
      if (type == "excretion") return "Bowel Movement";
    },
    getImage(type) {
      return require("../image/" + type + ".png");
    },
    selectRow(row, a, b) {
      if (this.expand[0] == row.id) this.expand = [];
      else this.expand = [row.id];
    },
    showMore() {
      this.showLess = true;
      this.showRows += 10;
    },
    showLessHandler() {
      this.showLess = false;
      this.showRows = 3;
    },
  },

  computed: {
    ...mapGetters("content", ["getContent", "getContentKey"]),
    lifestyle() {
      var lifestyle = [];

      ["food", "water", "excretion"].forEach((type) => {
        if (Array.isArray(this[type]) && this[type].length > 0)
          lifestyle.push({ id: type, event: this[type] });
      });
      return lifestyle;
    },
    displayLifestyle() {
      return this.lifestyle.slice(0, 3);
    },
    showMoreText() {
      return "Show more";
    },
    showLessText() {
      return "Show less";
    },
  },

  components: {
    ...FoodComponents,
    ...WaterComponents,
    ...ExcretionComponents,
    // SymptomAnalysis
  },
};
</script>

<style lang="scss" scoped>
.show-more, .el-button:hover, .el-button:focus {
  .el-button {
    display: block;
    width: 100%;
    font-size: 14px;
    color: #4a9bf9;
    font-weight: 600;
  }
  .el-icon-arrow-down {
    font-weight: 700;
  }
}

.lifestyle-icon {
  float: left;
  width: 24px;
  height: 24px;
}
</style>
